//   引入封装好的axios
//   ps:如果没有封装，正常引入axios即可
import axios from "./request";


export const fitswim_services = (data) => {
	return axios.post('/api/venue/region/list', data)
}

export const getCitysFromTemplate = (data) => {
	return axios.post('/api/cmbc/ffyd/getCitysFromTemplate', data)
}

// *********************************
export const getCitys = (data) => {
	return axios.post('/api/cmbc/ffyd-cc/getCitys', data)
}
export const getDistricts = (data) => {
	return axios.post('/api/cmbc/ffyd-cc/getDistricts', data)
}
export const getVenueServiceList = (data) => {
	return axios.post('/api/cmbc/ffyd-cc/getVenueServiceList', data)
}
export const getVenueServiceDetail = (data) => {
	return axios.post('/api/cmbc/ffyd-cc/getVenueServiceDetail', data)
}
export const getServiceAvailableDates = (data) => {
	return axios.post('/api/cmbc/ffyd-cc/getServiceAvailableDates', data)
}
export const login = (data) => {
	return axios.post('/api/cmbc/ffyd-cc/login', data)
}
export const createOrder = (data) => {
	return axios.post('/api/cmbc/ffyd-cc/createOrder', data)
}
export const getOrderDetail = (data) => {
	return axios.post('/api/cmbc/ffyd-cc/getOrderDetail', data)
}
export const cancelOrder = (data) => {
	return axios.post('/api/cmbc/ffyd-cc/cancelOrder', data)
}
export const getDtVerifyCode = (data) => {
	return axios.post('/api/cmbc/ffyd-cc/getDtVerifyCode', data)
}
export const modifyOrder = (data) => {
	return axios.post('/api/cmbc/ffyd-cc/modifyOrder', data)
}



export const getCitysFromTemplateV2 = (data) => {
	return axios.post('/api/cmbc/ffyd/getCitysFromTemplate', data)
}
export const getVenuesFromTemplateV2V2 = (data) => {
	return axios.post('/api/cmbc/ffyd/getVenuesFromTemplateV2', data)
}
export const getVenueDetailFromTemplateV2V2 = (data) => {
	return axios.post('/api/cmbc/ffyd/getVenueDetailFromTemplateV2', data)
}

/*
	index_city: jl + "/api/cmbc/ffyd/getCitysFromTemplate",
	getVenuesFromTemplate: jl + "/api/cmbc/ffyd/getVenuesFromTemplateV2",
	getVenueDetailFromTemplateV2: jl + "/api/cmbc/ffyd/getVenueDetailFromTemplateV2",
*/


// WEBPACK FOOTER //
// ./src/api/api.js